import React from "react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import localStyles from "../styles.module.scss";

interface ConfirmDialogProps {
    show: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmLabel?: string;
    variant?: "danger" | "primary";
}

const ConfirmDialog = ({
    show,
    title,
    message,
    onConfirm,
    onCancel,
    confirmLabel = "Delete",
    variant = "danger",
}: ConfirmDialogProps) => {
    const confirmBackground = variant === "danger" ? "bg-danger" : "bg-primary";

    return (
        <Modal
            show={show}
            handleClose={() => onCancel()}
            width={420}
            closeOut
            element={
                <div>
                    <div className={localStyles.modalTitle}>{title}</div>
                    <p className={localStyles.confirmMessage}>{message}</p>
                    <div className={localStyles.modalFooter}>
                        <Button
                            id="confirm-cancel"
                            size="small"
                            background="bg-outline-grey"
                            text="Cancel"
                            click={() => onCancel()}
                        />
                        <Button
                            id="confirm-action"
                            size="small"
                            background={confirmBackground}
                            text={confirmLabel}
                            click={() => onConfirm()}
                        />
                    </div>
                </div>
            }
        />
    );
};

export default ConfirmDialog;
